import LegalPage from "../../components/LegalPage";

export default function Terms() {
  return (
    <LegalPage
      badge="Legal"
      title="Terms & Conditions"
      lastUpdated="Feb 1, 2026"
      sections={[
        {
          heading: "Agreement to Terms",
          paragraphs: [
            "By accessing or using Brivo (the 'Service'), you agree to be bound by these Terms & Conditions ('Terms'). If you do not agree, please discontinue use of the Service.",
            "These Terms constitute a binding legal agreement between you and Brivo Inc. ('Brivo', 'we', 'our').",
          ],
        },
        {
          heading: "Eligibility",
          paragraphs: ["You must be at least 18 years old and legally capable of entering into binding contracts to use the Service. By using Brivo, you represent that you meet these requirements."],
        },
        {
          heading: "Account Responsibilities",
          paragraphs: ["You are responsible for safeguarding your account credentials and for all activity occurring under your account. You agree to:"],
          bullets: [
            "Provide accurate, current, and complete information when registering.",
            "Promptly update your information if it changes.",
            "Notify Brivo immediately of any unauthorized access to your account.",
          ],
        },
        {
          heading: "Acceptable Use",
          paragraphs: ["You agree not to misuse the Service. Prohibited conduct includes (but is not limited to) reverse engineering, attempting to disrupt our infrastructure, scraping data, or using the Service to violate any applicable law."],
        },
        {
          heading: "Subscriptions & Payments",
          paragraphs: ["Paid plans are billed in advance on a monthly or annual basis depending on your selection. Fees are non-refundable except as required by law or under our Refund Policy."],
        },
        {
          heading: "Intellectual Property",
          paragraphs: ["The Service, including all software, designs, and trademarks, is owned by Brivo and protected by intellectual property laws. You retain ownership of any content you submit to Brivo, but grant us a limited license to host and display it as required to operate the Service."],
        },
        {
          heading: "Termination",
          paragraphs: ["We may suspend or terminate your account at any time if you violate these Terms. Upon termination, your right to use the Service ceases immediately, but obligations such as payment for past services and indemnification will survive."],
        },
        {
          heading: "Disclaimer & Limitation of Liability",
          paragraphs: ["The Service is provided 'as is'. To the fullest extent permitted by law, Brivo disclaims all warranties and is not liable for indirect, consequential, or incidental damages arising from your use of the Service."],
        },
        {
          heading: "Changes to These Terms",
          paragraphs: ["We may update these Terms periodically. Material changes will be communicated via email or in-app notice 30 days in advance. Continued use of the Service after changes constitutes acceptance."],
        },
        {
          heading: "Governing Law",
          paragraphs: ["These Terms are governed by the laws of the State of Delaware, USA, without regard to conflict-of-law principles."],
        },
      ]}
    />
  );
}
